import {BasicClient} from '@/utils/httpClient';
import axios from 'axios';

export default class DigitalPost {
    client: BasicClient;

    constructor() {
        this.client = new BasicClient();
    }

    getAll(limit = 8, page = 1, current?: number){
        let url = `/v2/admin-mod/digitalposts?page=${page}&limit=${limit}`;
        if(current){
            url += `&estado=${current}`;
        }
        return this.client.exec(url, 'GET');
    }

    create(params: any){
        return this.client.exec(`/v2/admin-mod/digitalposts`, 'POST', params, true);
    }

    get(id: any){
        return this.client.exec(`/v2/admin-mod/digitalposts/${id}`, 'GET');
    }

    update(id, params){
        return this.client.exec(`/v2/admin-mod/digitalposts/${id}/edit`, 'POST', {
            ...params
        }, true);
    }

    delete(id: any){
        return this.client.exec(`/v2/admin-mod/digitalposts/${id}`, 'DELETE');
    }

    getFile(id: any, type?: string){
        return axios.get(`/v2/admin-mod/digitalposts/${id}/file`, {
            baseURL:  window.sichern.apiURL,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.jwt}`
            },
            responseType: 'arraybuffer'
        });
    }
}